import { i18n } from "..";

export enum TravelInsuranceTypeEnum {
  SINGLE = 'single',
  YEAR = 'year',
}

export const TravelInsuranceTypeEnumLabel = {
    [TravelInsuranceTypeEnum.SINGLE]: i18n.t('common.constants.travelInsuranceTypes.single'),
    [TravelInsuranceTypeEnum.YEAR]: i18n.t('common.constants.travelInsuranceTypes.year'),
}